export default {
      id: "txt_horizontal-line-usage",
      viewBox: "0 0 20 2",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#txt_horizontal-line",
      toString: function () {
        return this.url;
      }
    }